var utils = require('utils');

/**
 *
 * @param a
 * @param b
 * @param e
 * @return {Canvas}
 */
var cdf = function(a,b,e){
  if(typeof a === "function") return cdf.init(a);
  if(typeof a === 'number' && typeof b === 'number') return new cdf.Canvas(a,b,e);
}

utils.eventer(cdf);

cdf.init = function (callback) {
  if(cdf.initialized) {
    callback.call(cdf, [cdf, animate]);
    return this;
  }
  return cdf.on('init', callback);
};

cdf.Canvas = require('class/Canvas');
cdf.Image = require('class/Image');
cdf.Point = require('class/Point');
cdf.Points = require('class/Points');
cdf.Scene = require('class/Scene');
cdf.utils = utils;
cdf.color = require('inc/color');
cdf.shapes = require('inc/shapes');
cdf.animate = require('inc/animate');

cdf.Canvas.prototype.ngon     = require('method/Canvas.ngon');
cdf.Canvas.prototype.ellipse  = require('method/Canvas.ellipse');

module.exports = cdf;